import "core-js/modules/es.array.push.js";
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "content title"
};
const _hoisted_2 = {
  key: 0,
  class: "conclusion-card",
  open: ""
};
const _hoisted_3 = /*#__PURE__*/_createElementVNode("summary", {
  class: "conclusion-title"
}, "📌 核心结论", -1);
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
  key: 1,
  class: "main-wrap"
};
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = {
  key: 2,
  class: "think-box"
};
const _hoisted_8 = /*#__PURE__*/_createElementVNode("summary", null, "🧠 查看完整推理过程", -1);
const _hoisted_9 = ["innerHTML"];
import { ref } from 'vue';
import { showNotify } from '@nutui/nutui';
import axios from 'axios';
export default {
  __name: 'SiliconflowList',
  setup(__props, {
    expose: __expose
  }) {
    const timeNotify = msg => {
      showNotify.warn(msg, {
        duration: 2000
      });
    };
    const title = ref('');
    const isListVisible = ref(false);
    // 显示弹出框
    const show = (matchId, status) => {
      isListVisible.value = true;
      getFixedBonusV1(matchId, status);
      // getRecommended(matchId);
    };
    const oddsHistory = ref({});
    const siliconflowList = ref([]);
    const getFixedBonusV1 = async (matchId, status) => {
      try {
        const response2 = await axios.get('https://tuhaojie.asia/api-foot/siliconflow/getList?matchId=' + matchId + "&status=" + status);
        let data2 = response2.data;
        let list = [];
        for (let i = 0; i < data2.length; i++) {
          const item = data2[i];
          list.push({
            ...item,
            parsed: parseContent(item.content)
          });
        }
        siliconflowList.value = list;
        const response = await axios.get('https://webapi.sporttery.cn/gateway/uniform/football/getFixedBonusV1.qry?clientCode=3001&matchId=' + matchId);
        let data = response.data;
        if (data.success) {
          oddsHistory.value = data.value.oddsHistory;
          title.value = oddsHistory.value.homeTeamAbbName + ' VS ' + oddsHistory.value.awayTeamAbbName;
        } else {
          timeNotify(data.errorMessage);
        }
      } catch (error) {
        // 处理错误
        console.error(error);
      }
    };

    /**
     * 解析 AI 内容：拆分推理过程 / 核心结论 / 正文章节
     * - think：DeepSeek-R1 的 <think> 推理块（超长，默认折叠）
     * - conclusion：从"最终预测/投注建议"标题截取的核心结论（置顶展示）
     * - sections：正文按 ### 标题拆分的可折叠章节数组
     */
    const parseContent = content => {
      if (!content) return {
        think: '',
        conclusion: '',
        sections: []
      };
      let text = content;
      let think = '';
      const thinkMatch = text.match(/<think>([\s\S]*?)<\/think>/);
      if (thinkMatch) {
        think = thinkMatch[1].trim();
        text = text.replace(/<think>[\s\S]*?<\/think>/, '');
      }
      text = text.trim();
      let conclusion = '';
      const conclusionMatch = text.match(/###\s*(\*\*)?\s*\d*\.?\s*最终预测[\s\S]*/);
      if (conclusionMatch) {
        conclusion = conclusionMatch[0];
      } else {
        const c2 = text.match(/###\s*(\*\*)?\s*投注建议[\s\S]*/);
        if (c2) conclusion = c2[0];
      }
      let main = text;
      if (conclusion) {
        main = text.replace(conclusion, '').trim();
      }
      return {
        think,
        conclusion,
        sections: splitSections(main)
      };
    };

    /**
     * 按 ### 标题将正文拆分为可折叠章节
     * @param {string} text markdown 正文
     * @return {Array<{title:string, body:string}>} 章节数组
     */
    const splitSections = text => {
      if (!text) return [];
      const sections = [];
      let current = null;
      const lines = text.split('\n');
      for (const line of lines) {
        const m = line.match(/^###\s+(.*)$/);
        if (m) {
          if (current) sections.push(current);
          current = {
            title: m[1].replace(/\*\*/g, '').trim(),
            body: ''
          };
        } else if (current) {
          current.body += line + '\n';
        }
      }
      if (current) sections.push(current);
      return sections;
    };

    // 改进的 Markdown 渲染：标题/加粗/表格/列表/代码块
    const renderMarkdown = text => {
      if (!text) return '';
      let t = text;
      // 标题
      t = t.replace(/^###### (.*)$/gm, '<h6>$1</h6>');
      t = t.replace(/^##### (.*)$/gm, '<h5>$1</h5>');
      t = t.replace(/^#### (.*)$/gm, '<h4>$1</h4>');
      t = t.replace(/^### (.*)$/gm, '<h3>$1</h3>');
      t = t.replace(/^## (.*)$/gm, '<h2>$1</h2>');
      // 代码块（先处理，避免内部被其它正则污染）
      t = t.replace(/```(\w*)\n([\s\S]*?)```/g, (m, lang, code) => `<pre><code class="${lang || ''}">${code.trim()}</code></pre>`);
      // 表格（连续行合并为一个 table）
      t = t.replace(/((?:\|[^\n]*\|\n?)+)/g, m => {
        const rows = m.trim().split('\n').filter(r => r.trim().startsWith('|'));
        if (!rows.length) return m;
        const trs = rows.map(r => {
          const cells = r.replace(/^\||\|$/g, '').split('|').map(c => c.trim());
          return '<tr>' + cells.map(c => `<td>${c}</td>`).join('') + '</tr>';
        }).join('');
        return `<table>${trs}</table>`;
      });
      // 无序列表（连续项合并）
      t = t.replace(/((?:^[-*] .*(?:\n|$))+)/gm, m => {
        const items = m.replace(/^[-*] /gm, '').split('\n').filter(Boolean).map(x => `<li>${x}</li>`).join('');
        return `<ul>${items}</ul>`;
      });
      // 有序列表（连续项合并）
      t = t.replace(/((?:^\d+\. .*(?:\n|$))+)/gm, m => {
        const items = m.replace(/^\d+\. /gm, '').split('\n').filter(Boolean).map(x => `<li>${x}</li>`).join('');
        return `<ol>${items}</ol>`;
      });
      // 加粗斜体
      t = t.replace(/\*\*(.*?)\*\*/gm, '<strong>$1</strong>');
      t = t.replace(/\*(.*?)\*/gm, '<em>$1</em>');
      // 链接
      t = t.replace(/\[(.*?)\]\((.*?)\)/gm, '<a href="$2">$1</a>');
      return t;
    };
    // 关闭弹出框
    const close = () => {
      isListVisible.value = false;
    };

    // 暴露给外部使用的函数
    __expose({
      show,
      close
    });
    return (_ctx, _cache) => {
      const _component_nut_col = _resolveComponent("nut-col");
      const _component_nut_row = _resolveComponent("nut-row");
      const _component_nut_collapse_item = _resolveComponent("nut-collapse-item");
      const _component_nut_collapse = _resolveComponent("nut-collapse");
      const _component_nut_popup = _resolveComponent("nut-popup");
      return _openBlock(), _createBlock(_component_nut_popup, {
        visible: isListVisible.value,
        "onUpdate:visible": _cache[0] || (_cache[0] = $event => isListVisible.value = $event),
        closeable: "",
        style: {
          padding: '24px 2px',
          height: '85%',
          width: '92%',
          overflow: 'auto'
        }
      }, {
        default: _withCtx(() => [_createVNode(_component_nut_row, null, {
          default: _withCtx(() => [_createVNode(_component_nut_col, {
            span: 24
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_1, _toDisplayString(title.value), 1)]),
            _: 1
          })]),
          _: 1
        }), _createVNode(_component_nut_collapse, null, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(siliconflowList.value, (siliconflow, index) => {
            return _openBlock(), _createBlock(_component_nut_collapse_item, {
              name: index,
              key: index
            }, {
              title: _withCtx(() => [_createTextVNode(_toDisplayString(siliconflow.createTime), 1)]),
              default: _withCtx(() => [siliconflow.parsed.conclusion ? (_openBlock(), _createElementBlock("details", _hoisted_2, [_hoisted_3, _createElementVNode("div", {
                innerHTML: renderMarkdown(siliconflow.parsed.conclusion),
                class: "markdown-content"
              }, null, 8, _hoisted_4)])) : _createCommentVNode("", true), siliconflow.parsed.sections && siliconflow.parsed.sections.length ? (_openBlock(), _createElementBlock("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(siliconflow.parsed.sections, (sec, si) => {
                return _openBlock(), _createElementBlock("details", {
                  key: si,
                  class: "sec-box"
                }, [_createElementVNode("summary", null, _toDisplayString(sec.title), 1), _createElementVNode("div", {
                  innerHTML: renderMarkdown(sec.body),
                  class: "markdown-content"
                }, null, 8, _hoisted_6)]);
              }), 128))])) : _createCommentVNode("", true), siliconflow.parsed.think ? (_openBlock(), _createElementBlock("details", _hoisted_7, [_hoisted_8, _createElementVNode("div", {
                innerHTML: renderMarkdown(siliconflow.parsed.think),
                class: "markdown-content think"
              }, null, 8, _hoisted_9)])) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["name"]);
          }), 128))]),
          _: 1
        })]),
        _: 1
      }, 8, ["visible"]);
    };
  }
};